import { CTA } from '../ui/CTA'
import { Container } from '../ui/Container'

export function Hero() {
  return (
    <section className="relative overflow-hidden border-b border-ink/10 bg-paper pt-16 pb-24 md:pt-24 md:pb-32">
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.4]"
        style={{
          backgroundImage:
            'linear-gradient(to right, var(--grid-line) 1px, transparent 1px), linear-gradient(to bottom, var(--grid-line) 1px, transparent 1px)',
          backgroundSize: '56px 56px',
          maskImage: 'radial-gradient(ellipse 80% 60% at 50% 30%, black 40%, transparent 100%)',
        }}
      />

      <div className="pointer-events-none absolute -right-24 top-24 hidden h-72 w-72 rounded-full bg-signal/10 blur-3xl md:block" />

      <Container className="relative">
        <div className="flex items-center gap-2 text-xs font-medium uppercase tracking-[0.2em] text-stone">
          <span className="flex h-2 w-2 animate-pulse rounded-full bg-signal" />
          Technology company
        </div>

        <h1 className="mt-8 max-w-4xl font-display text-5xl font-semibold leading-[1.04] tracking-tight text-balance sm:text-6xl md:text-7xl">
          We build what businesses need next.
        </h1>

        <p className="mt-8 max-w-xl text-lg leading-relaxed text-graphite">
          Limitlast is a technology company designing and building digital products, software, and
          systems for organizations ready to evolve.
        </p>

        <div className="mt-10 flex flex-wrap items-center gap-4">
          <CTA to="/contact" variant="primary">
            Start a project
          </CTA>
          <CTA to="/cases" variant="secondary">
            Explore our work
          </CTA>
        </div>

        <div className="mt-24 grid grid-cols-2 gap-8 border-t border-ink/10 pt-8 sm:grid-cols-4">
          {[
            { label: 'Understand', n: '01' },
            { label: 'Design', n: '02' },
            { label: 'Build', n: '03' },
            { label: 'Evolve', n: '04' },
          ].map((step) => (
            <div key={step.n} className="flex items-baseline gap-3">
              <span className="font-display text-sm text-signal">{step.n}</span>
              <span className="text-sm font-medium text-ink/70">{step.label}</span>
            </div>
          ))}
        </div>
      </Container>
    </section>
  )
}
